<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoSessionStateInAuthResponse` — the `session_state`
 * parameter was missing from the Keycloak OAuth callback. Keycloak includes
 * `session_state` to link the browser session to the SSO session; its absence
 * indicates a malformed or unexpected callback. Delegates all rendering to
 * `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoSessionStateInAuthResponse" />
</template>
